import { autoinject, bindable, BindingEngine, computedFrom, transient, useView } from "aurelia-framework";
import { I18N } from "aurelia-i18n";
import { MobileHelper } from "../../../../../../helpers/mobile-helper";
import { DataGridColumn, DataType, QueryFilter, SourceType } from "../../../../../../models/queries/queries.models";
import { FromNowValueConverter } from "../../../../../components/converters/date/date-format";
import { CustomGridPageBase } from "../../../../common/custom-grid-page.base";

@autoinject()
@transient()
@useView('views/pages/modules/orders/plugins/vessel-rightship-inspection-report/selected-vessel-inspections.html')
export class SelectedVesselInspections extends CustomGridPageBase {

    @bindable
    public vesselId: number;
    
    @computedFrom("dataGridVM")
    public get inspections() {
        return this.dataGridVM.getSelectedRowsCollection()
    }
    
    constructor(protected i18N: I18N,
        protected bindingEngine: BindingEngine) {
        super(i18N, "Vessel Inspections", bindingEngine)
    }

    getColumns() {
        const columns = [];

        columns.push(
            {
                columnOrder: 6,
                sortOrder: 1,
                dataType: DataType.CustomTemplate,
                instancePerRow: true,
                isSortable: true,
                name: 'select',
                title: 'Select',
                value: () => '<div>' +
                    '<radio-button checked.two-way="getRowItem().isSelected" group="list-select-group"></radio-button>' +
                    '</div>',
                parameter: {
                    item: null,
                }
            },
            {
                columnOrder: 0,
                sortOrder: 0,
                dataType: DataType.Default,
                isSortable: true,
                name: 'portName',
                title: 'Port',
                isAscending: true,
                width: MobileHelper.isMobileDevice() && window.innerWidth < 1024 ? "" : "200px",
            },
            {
                columnOrder: 7,
                sortOrder: 7,
                dataType: DataType.CustomTemplate,
                isSortable: true,
                instancePerRow: true,
                name: 'inspectionDate',
                title: 'Inspection Date',
                isAscending: true,
                value: '<div><p style="font-size: 1.3rem;">${item.inspectionDate | dateFormat: "DD MMM YYYY HH:mm"}</p></div>',
                parameter: {
                    item: null,
                }
            },
            {
                columnOrder: 6,
                sortOrder: 1,
                dataType: DataType.CustomTemplate,
                instancePerRow: true,
                isSortable: true,
                name: 'status',
                title: 'Status',
                value: () => 
                    '<div class="status-badge-value" if.bind="item.status">' +
                    '<div class="row nowrap align-items-middle">' +
                    '<div class="status-badge-dot"></div>' +
                    '<span>${item.status == "Review Required"?"Pending Review":item.status}</span>' +
                    '</div>' +
                    '<span class="status-date">${getDateToString(item.statusDate)}</span>' +
                    '</div>',
                getCellClass: (item: { status: string }) => {
                    return (item && item.status) ? `status-badge ${item.status.toLowerCase().replace(/[^A-z0-9]+/g, '-')}` : '';
                },
                parameter: {
                    item: null,
                    getDateToString: (date: Date | string) => this.getDateToString(date)
                }
            }
        );

        columns.forEach((column, index) => {
            column.columnOrder = index;
            column.sortOrder = index;
        });

        return columns;
    }
    
    getDateToString(date: Date | string): string {
        if (!date)
            return 'N/A'

        let val: Date;

        if (typeof date == 'string')
            val = new Date(date);
        else
            val = date

        if (val.getUTCMonth() == 0 && val.getUTCDay() == 1 && val.getUTCFullYear() == 1900)
            return 'N/A';

        return new FromNowValueConverter().toView(val);
    }

    getSorting() {
        const columns: DataGridColumn[] = [];
        columns.push(
            <DataGridColumn>{
                columnOrder: -1,
                sortOrder: 2,
                dataType: DataType.Default,
                isSortable: true,
                isAscending: false,
                isHidden: true,
                name: 'portName',
                title: 'Port'
            },
            {
                columnOrder: -1,
                sortOrder: 1,
                dataType: DataType.DateTime,
                isSortable: true,
                isAscending: true,
                isHidden: true,
                name: 'inspectionDate',
                title: 'Inspection Date'
            },
            {
                columnOrder: -1,
                sortOrder: 3,
                dataType: DataType.Default,
                isSortable: true,
                isAscending: true,
                isHidden: true,
                name: 'status',
                title: 'Status'
            });
        return columns;
    }

    vesselIdChanged(){
        this.itemSource = {
            sourceType: SourceType.ODataUrl,
            source: 'odata/RightShipInspections',
            columns: this.getColumns(),
            initialFilters: [QueryFilter.getQuery("vesselId", this.vesselId, "eq", DataType.Number)],
            initialSorting: this.getSorting()
        };
    }
}